import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SectionNav.css';

export const SECTION_ROUTES = {
    formEditor: '/form-editor',
    applicationStatusEditor: '/application-status-editor',
} as const;

const SECTIONS = [
    { path: SECTION_ROUTES.formEditor,              label: 'Form Editor' },
    { path: SECTION_ROUTES.applicationStatusEditor, label: 'Application Status Editor' },
];

const SectionNav: React.FC = () => {
    const { pathname } = useLocation();

    return (
        <nav className="section-nav">
            {SECTIONS.map(({ path, label }) => (
                <Link
                    key={path}
                    to={path}
                    className={`section-nav__tab${pathname.startsWith(path) ? ' section-nav__tab--active' : ''}`}
                >
                    {label}
                </Link>
            ))}
        </nav>
    );
};

export default SectionNav;
